// extracted by mini-css-extract-plugin
export var imageHolder = "trainer-module--image-holder--aypfl";
export var name = "trainer-module--name--RGJbR";
export var nameHolder = "trainer-module--name-holder--Lj6NG";
export var title = "trainer-module--title--U8Cnk";
export var titleHolder = "trainer-module--title-holder--9sULQ";
export var wrapper = "trainer-module--wrapper--TzIPx";